import filterRender from './components/FilterBox'
const millage = {
  renderDefault: (_renderOpts: Recordable, { row, column }: Recordable) => {
    const value: number = Number(row[column.field])
    if (isNaN(value)) return '-'
    const str = `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return <span>{str}</span>
  }
}

export const renders = [
  { name: 'millage', options: millage },
  { name: 'filterRender', options: filterRender }
]
